import { t } from '@lingui/core/macro'
import { CreateUser } from './CreateUser'
import { SignupContainer } from './SignupContainer'

export function FreeSignup({
  allowAppPromotion,
}: {
  allowAppPromotion: boolean
}) {
  return (
    <SignupContainer title={t`Create a free account`}>
      <CreateUser
        allowAppPromotion={allowAppPromotion}
        type="private"
        federationIntent={{
          case: 'signup',
          value: {},
        }}
      />
    </SignupContainer>
  )
}
